import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

// 引入组件
import Tools from './components';
import moment from 'moment'

Vue.prototype.$moment = moment;

//引入antd-vue
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
//引入bootstrap样式
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
//引入iconfont样式
import './assets/font/iconfont.css'
//引入全局公共样式
import './assets/css/common.css'


//关闭生产提示
Vue.config.productionTip = false

Vue.use(Tools)
Vue.use(Antd)
Vue.use(router)

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
